/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCollapsible/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TysiaCollapsible({
  children,
  viewPath = "/DesignSystem/TysiaCollapsible",
  isOpen,
  onToggle
  
}) {
  return (<React.Fragment
>
<Children
  viewPath={`${viewPath}/Children`}
 isOpen={isOpen}
 onToggle={onToggle}
>
{children}
</Children>
</React.Fragment>)
}